import React from "react";
import { SwipeableDrawer, Box, useTheme, useMediaQuery } from "@mui/material";
export const BDrawer = ({ open, onClose, onOpen = () => { }, // No-op fallback
children, height = "50%", p = 2, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    return (React.createElement(SwipeableDrawer, { anchor: "bottom", open: open, onClose: onClose, onOpen: onOpen, disableDiscovery: !isMobile, disableSwipeToOpen: !isMobile, slotProps: {
            paper: {
                sx: {
                    height,
                    borderTopLeftRadius: 18,
                    borderTopRightRadius: 18,
                    padding: p,
                },
            },
        } },
        React.createElement(Box, { sx: { position: "relative", width: "100%" } },
            React.createElement(Box, { sx: {
                    width: 40,
                    height: 4,
                    backgroundColor: "grey.400",
                    borderRadius: 2,
                    position: "absolute",
                    top: 8,
                    left: "50%",
                    transform: "translateX(-50%)",
                } }),
            React.createElement(Box, { sx: { pt: 2 } }, children))));
};
